import {
  Button,
  Typography,
  Header,
  Avatar,
  Spacing,
  MyTextInput,
  MyModal,
} from 'components/src';
import React, {
  Dispatch,
  FC,
  SetStateAction,
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import {
  Platform,
  createUseStyles,
  routesName,
  useGetChatSearchMessageInConversation,
  useLang,
} from 'core/src';
import { StackNavigationProp } from '@react-navigation/stack';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import Fontisto from 'react-native-vector-icons/Fontisto';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {
  setScrollData,
  setSearching,
  Store,
} from '../../templates/chatScreen/store';
import { SocketIOContext } from '../../app/appcontainer';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;
const MaterialCommunityIconsX =
  MaterialCommunityIcons as unknown as React.ComponentType<any>;
const FontistoX = Fontisto as unknown as React.ComponentType<any>;
const FontAwesomeX = FontAwesome as unknown as React.ComponentType<any>;

interface ChatHeaderProps {
  navigation: StackNavigationProp<any>;
  search: boolean;
  setSearch: Dispatch<SetStateAction<boolean>>;
  name: string;
  avatar?: any;
  setSearchText?: any;
  searchText?: string;
  setOpen?: any;
  longPress: any;
  conversationId: string;
  handleDelete: any;
  openBottomSheet: any;
  status: string;
  isChannelAdmin?: boolean;
  selectedItems: any;
  setSelectedItems: any;
  serachData: any;
  isPinned: boolean;
  situation: string;
  setCountClick: any;
}

const ChatHeader: FC<ChatHeaderProps> = memo(
  ({
    navigation,
    search,
    setSearch,
    name,
    avatar,
    isPinned,
    conversationId,
    // setSearchText,
    setOpen,
    longPress,
    // searchText,
    handleDelete,
    openBottomSheet,
    status,
    isChannelAdmin,
    selectedItems,
    setSelectedItems,
    serachData,
    situation,
    setCountClick,
  }) => {
    const { styles } = useStyles();
    const { lang } = useLang();
    const { colors, theme } = useStyles();
    const { i18n } = useTranslation();
    const [searchText, setSearchText] = useState('');
    const [shouldSearch, setShouldSearch] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [modalVisible, setModalVisible] = useState(false);
    const [pinState, setPinState] = useState(false);

    const dispatch = Store.useDispatch();
    const state = Store.useState();

    const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const handleBack = () => {
      navigation.navigate(routesName.CONVERSATIONS);
    };

    const handleModalClose = () => {
      setModalVisible(false);
    };

    const openProfileHandler = () => {
      Platform.isDesktop
        ? setOpen('profileContact')
        : navigation.navigate(routesName.PROFILECONTACT, {
            conversationId: conversationId,
            isChannelAdmin: isChannelAdmin,
            avatar: avatar,
          });
    };

    const handleUp = () => {
      setCurrentIndex((prevIndex) => {
        const newIndex = prevIndex + 1;
        return newIndex > state.searchItem.length ? 1 : newIndex;
      });
      setCountClick((countClick: number) => countClick + 1);
    };

    const handleDown = () => {
      setCurrentIndex((prevIndex) => {
        const newIndex = prevIndex - 1;
        return newIndex < 1 ? state.searchItem.length : newIndex;
      });
      setCountClick((countClick: number) => countClick + 1);
    };

    useEffect(() => {
      if (
        state.searchItem?.length > 0 &&
        !selectedItems?.includes(state.searchItem[currentIndex]) &&
        currentIndex !== 0
      ) {
        setSelectedItems(
          (prevItems: any) => [state.searchItem[currentIndex - 1]]?.[0]?.id,
        );
      }
    }, [currentIndex]);

    useEffect(() => {
      !search && setSearchText('');
    }, [search]);

    const handleSearchChange = useCallback(
      (text: any) => {
        if (typingTimeoutRef.current) {
          clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
          setSearchText(text);
        }, 50);
      },
      [setSearchText],
    );

    const { data, refetch } = useGetChatSearchMessageInConversation(
      {
        conversationId,
        message: searchText,
      },
      {
        enabled: false,
        refetchOnWindowFocus: false,
        retry: 0,
      },
    );

    useEffect(() => {
      setPinState(isPinned);
    }, [isPinned]);

    useEffect(() => {
      if (shouldSearch && searchText.trim() !== '') {
        refetch();
        setShouldSearch(false);

        setCurrentIndex(0);
      }
    }, [shouldSearch, refetch]);

    useEffect(() => {
      dispatch(setSearching(data?.data.messages?.messages));
    }, [data]);

    useEffect(() => {
      dispatch(setScrollData(serachData?.data?.messages));
    }, [serachData]);

    const handlePin = () => {
      SocketIOContext.invoke('pinConversation', {
        conversationId: conversationId,
        isPinned: true,
      });
      setModalVisible(false);
      setPinState(!pinState);
    };

    const handleUnpin = () => {
      SocketIOContext.invoke('pinConversation', {
        conversationId: conversationId,
        isPinned: false,
      });
      setModalVisible(false);
      setPinState(!pinState);
    };

    return (
      <Header
        classes={{
          flexDirection: lang === 'fa-IR' ? 'row-reverse' : 'row',
        }}
      >
        <MyModal
          animationType={'slide'}
          handleModalClose={handleModalClose}
          modalVisible={modalVisible}
          classesIn={styles.modalContent}
          classesOut={[
            styles.modalContainer,
            { alignItems: lang === 'fa-IR' ? 'flex-start' : 'flex-end' },
          ]}
        >
          <View>
            <View
              style={{
                backgroundColor: colors.dropdownContent,

                padding: 5,
              }}
            >
              {pinState ? (
                <Button flexDirection={'row'} onClick={handleUnpin}>
                  <MaterialCommunityIconsX
                    name="pin-off"
                    size={21}
                    color={
                      theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                    }
                  />
                  <Spacing horizontal={1} />
                  <Typography
                    text={i18n.t('unpinConversation')}
                    color={
                      theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                    }
                  />
                </Button>
              ) : (
                <Button flexDirection={'row'} onClick={handlePin}>
                  <FontistoX
                    name="pinboard"
                    size={21}
                    color={
                      theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                    }
                  />
                  <Spacing horizontal={1} />
                  <Typography
                    text={i18n.t('pinConversation')}
                    color={
                      theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                    }
                  />
                </Button>
              )}
            </View>
            <Spacing vertical={5} />
            <View
              style={{
                backgroundColor: colors.dropdownContent,

                padding: 5,
              }}
            >
              <Button
                flexDirection={'row'}
                // onClick={() => {
                //   setSearch(true);
                //   setModalVisible(false);
                // }}
              >
                <MaterialIconsX
                  name="wallpaper"
                  size={22}
                  color={
                    theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                  }
                />
                <Spacing horizontal={1} />
                <Typography
                  text={i18n.t('setWallpaper')}
                  color={
                    theme === 'rose' || theme === 'dark' ? 'white' : 'black'
                  }
                />
              </Button>
            </View>
          </View>
        </MyModal>
        {(Platform.isPwa || Platform.isNative) && !search && (
          <Button onClick={handleBack}>
            <MaterialIconsX
              name={lang === 'fa-IR' ? 'arrow-forward' : 'arrow-back'}
              size={25}
              color={colors.white}
            />
          </Button>
        )}
        {state.searchItem?.length > 0 && (
          <>
            <View
              style={{
                flexDirection: 'row',
                width: 50,
              }}
            >
              <Button onClick={handleUp}>
                <MaterialIconsX
                  name="keyboard-arrow-up"
                  size={25}
                  color={colors.white}
                />
              </Button>
              <Button
                onClick={handleDown}
                disabled={
                  currentIndex === 0 || currentIndex === 1 ? true : false
                }
              >
                <MaterialIconsX
                  name="keyboard-arrow-down"
                  size={25}
                  color={colors.white}
                />
              </Button>
            </View>
            <Typography
              text={
                state.searchItem?.length > 0
                  ? `${currentIndex}/${state.searchItem?.length}`
                  : 'Searching...'
              }
            />
          </>
        )}

        {search ? (
          <>
            <Spacing horizontal={7} />
            <MyTextInput
              change={handleSearchChange}
              classes={styles.input}
              placeholder={i18n.t('search')}
              focus={search ? true : false}
              inlineImageRight={
                searchText !== '' && (
                  <Button onClick={() => setShouldSearch(true)}>
                    <MaterialIconsX name="search" size={25} />
                  </Button>
                )
              }
            />
          </>
        ) : (
          <>
            <View style={[styles.info]}>
              <Button
                flexDirection={lang === 'fa-IR' ? 'row-reverse' : 'row'}
                onClick={openProfileHandler}
              >
                <Avatar
                  source={avatar}
                  openImage={false}
                  radius={50}
                  size={55}
                  statusShow={true}
                  status={status}
                  situation={situation}
                />
                <Spacing horizontal={10} />
                <View style={{ flexDirection: 'column', alignItems: 'center' }}>
                  <Typography
                    text={name}
                    color={colors.white}
                    size={16}
                    weight="bold"
                    classes={{ marginTop: 20 }}
                  />
                  <Typography
                    text={
                      situation
                        ? status === 'offline'
                          ? i18n.t('offline')
                          : i18n.t(situation)
                        : status
                    }
                    color={
                      theme === 'light' || theme === 'rose'
                        ? 'orange'
                        : '#CDC1FF'
                    }
                    size={12}
                    weight="bold"
                    classes={{ marginTop: 10 }}
                  />
                </View>
              </Button>
            </View>
            <Spacing horizontal={18} />
            {longPress?.length > 0 && (
              <View style={{ flexDirection: 'row' }}>
                <Button onClick={handleDelete}>
                  <MaterialCommunityIconsX
                    name="delete"
                    size={21}
                    color={'#FF6868'}
                  />
                </Button>
                <Spacing horizontal={6} />
                <Button onClick={openBottomSheet}>
                  <FontAwesomeX
                    name="mail-forward"
                    size={21}
                    color={colors.white}
                  />
                </Button>
              </View>
            )}
          </>
        )}
        {search ? (
          <Button
            onClick={() => {
              setSearch(false);
              dispatch(setSearching([]));
              dispatch(setScrollData([]));
              setSelectedItems([]);
              setCurrentIndex(0);
            }}
          >
            <MaterialIconsX name="close" size={25} color={colors.white} />
          </Button>
        ) : (
          <>
            <View
              style={{
                flexDirection: lang === 'fa-IR' ? 'row-reverse' : 'row',
              }}
            >
              <Button
                onClick={() => {
                  setSearch(true);
                  setModalVisible(false);
                }}
              >
                <MaterialIconsX name="search" size={25} color={colors.white} />
              </Button>
              <Spacing horizontal={10} />
              <Button
                onClick={() => {
                  setModalVisible(true);
                }}
              >
                <MaterialIconsX
                  name="more-vert"
                  size={25}
                  color={colors.white}
                  style={{ display: modalVisible ? 'none' : 'flex' }}
                />
              </Button>
            </View>
          </>
        )}
      </Header>
    );
  },
);

const useStyles = createUseStyles(({ colors, theme }) => ({
  info: {
    alignItems: 'center',
  },
  input: {
    flex: 1,
    backgroundColor: 'transparent',
    elevation: 0,
    textAlign: 'left',
  },
  modalContainer: {
    marginTop: 15,
    marginRight: 10,
  },

  modalContent: {
    width: 200,
    height: 125,
    elevation: 3,
    backgroundColor: colors.dropdown,
  },
}));

export { ChatHeader };
